module.exports = __webpack_public_path__ + "media/images/icons/self-storage-small-5x5-icon-8a62381d8b862f478e8deb023aeb4b35.png";